import { SOURCE_LOCALE_ID } from "@bitcart/core/i18n";
import { modifyUrl } from "vike/modifyUrl";
//#region src/lifecycle/before-route.ts
const createOnBeforeRoute = ({ supportedLocaleIds }) => {
	const extractLocale = ({ href, pathname }) => {
		const leadingPathSegment = pathname.split("/").slice(1)[0];
		const routeLocaleId = supportedLocaleIds.includes(leadingPathSegment) ? leadingPathSegment : null;
		const urlWithoutLocale = routeLocaleId === null ? href : modifyUrl(href, { pathname: `/${pathname.split("/").slice(2).join("/")}` });
		return {
			localeId: routeLocaleId ?? SOURCE_LOCALE_ID,
			urlWithoutLocale
		};
	};
	return function onBeforeRoute(pageContext) {
		const { localeId, urlWithoutLocale } = extractLocale(pageContext.urlParsed);
		return { pageContext: {
			localeId,
			urlLogical: urlWithoutLocale
		} };
	};
};
//#endregion
export { createOnBeforeRoute };

//# sourceMappingURL=before-route.js.map